// This file is used in several weird places, so avoid any other imports here
// Only BRANCH is available
import ClientVersion from "src/types/ClientVersion";

const notProd = process.env.BRANCH !== "prod" && process.env.BRANCH !== "dogfooding";

const clientVersion: ClientVersion = "1.0.90";
export default clientVersion;
